import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-redirect-preserve-params',
    template: '',
    standalone: true,
})
export class RedirectPreserveParamsComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);

    ngOnInit(): void {
        const params = { ...this.route.snapshot.queryParams };
        this.router.navigate(['/password/forgot-password/set-password'], {
            queryParams: params,
            replaceUrl: false,
        });
    }
}
